
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.898 10.43l-.003-.002-1.763 1.763-2.64-2.646 1.763-1.76a1.869 1.869 0 012.643 2.644zm-3.661 3.656l-2.643-2.642 1.018-1.018 2.643 2.643-1.018 1.017zM12.79 35.533l-2.644-2.642 20.566-20.566 2.643 2.642L12.79 35.533zm-4.984 2.341l1.667-3.889 2.223 2.222-3.89 1.667zm30.96-30.962a3.115 3.115 0 00-4.394-.01h.002l-4.102 4.101L8.826 32.45c-.006.006-.008.014-.014.02a.604.604 0 00-.118.176l-.005.011-2.64 6.155a.625.625 0 00.819.818l6.156-2.639.01-.004a.614.614 0 00.177-.119c.005-.005.013-.006.019-.013l21.447-21.447 4.1-4.1a3.114 3.114 0 00-.01-4.396z"}})])
          )
        }
      }
    